import { nothing as A } from '../lit-html.js';

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var l = function l(_l) {
  return null != _l ? _l : A;
};

export { l as ifDefined };
